export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-700 via-primary-800 to-primary-950 p-8 md:p-12">
          <div className="absolute top-0 right-0 w-72 h-72 bg-accent-500/15 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-56 h-56 bg-background-50/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative z-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-50/15 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-accent-400"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
              投稿爆料
            </h2>
            <p className="text-sm text-background-300/80 leading-relaxed max-w-lg mx-auto mb-8">
              你有独家爆料线索？欢迎匿名投稿至吃瓜爆料平台。所有投稿信息严格保密，
              优质爆料内容将优先审核发布并参与吃瓜爆料每日大赛评选。
              投稿即视为授权平台在脱敏处理后公开发布。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
              <div className="flex items-center gap-2 text-background-300/70 text-sm">
                <i className="ri-mail-line text-accent-400"></i>
                <span>tougao@chigua-baoliao.com</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-background-300/30"></div>
              <div className="flex items-center gap-2 text-background-300/70 text-sm">
                <i className="ri-shield-check-line text-accent-400"></i>
                <span>匿名投稿 · 信息加密 · 严格保密</span>
              </div>
            </div>

            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-foreground-950 font-bold rounded-lg hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-send-plane-fill"></i>
              <span>立即投稿</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}